import React, { useState } from "react";

const DynamicTable = () => {
  const initialData = [
    { id: 1, text: "Iken", gender: "Male" },
    { id: 2, text: "Ramen", gender: "Male" },
    { id: 3, text: "Tina", gender: "Female" }
  ]
  const [rows, setRows] = useState(initialData);

  // Function to update text input
  const handleTextChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].text = value;
    setRows(updatedRows);
  };

  // Function to update gender selection
  const handleGenderChange = (index, value) => {
    const updatedRows = [...rows];
    updatedRows[index].gender = value;
    setRows(updatedRows);
  };

  // Function to add a new row after the current one
  const addRowAfter = (index) => {
    const newRow = { id: Date.now(), text: "", gender: "Male" };
    const updatedRows = [...rows];
    updatedRows.splice(index + 1, 0, newRow);
    setRows(updatedRows);
  };

  // Function to remove a row (ensuring at least one row remains)
  const removeRow = (index) => {
    if (rows.length > 1) {
      const updatedRows = rows.filter((_, i) => i !== index);
      setRows(updatedRows);
    }
  };
  console.log("UYT12", rows);


  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div className="mt-5">
            <h2 className="text-center">
              Dynamic Table
            </h2>
            <section className="chartBox_area">
              <div className="p-4">
                <table className="border-collapse border border-gray-400 w-full">
                  <thead>
                    <tr>
                      <th className="border border-gray-400 p-2">Actions</th>
                      <th className="border border-gray-400 p-2">Text Input</th>
                      <th className="border border-gray-400 p-2">Gender</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={row.id}>
                        <td className="border border-gray-400 p-2 space-x-2">
                          <button
                            className="bg-blue-500 text-white px-2 py-1 rounded"
                            onClick={() => addRowAfter(index)}
                          >
                            Add
                          </button>
                          <button
                            className="bg-red-500 text-white px-2 py-1 rounded"
                            onClick={() => removeRow(index)}
                            disabled={rows.length === 1}
                          >
                            Remove
                          </button>
                        </td>
                        <td className="border border-gray-400 p-2">
                          <input
                            type="text"
                            value={row.text}
                            onChange={(e) => handleTextChange(index, e.target.value)}
                            className="border p-1 w-full"
                            placeholder="Enter text"
                          />
                        </td>
                        <td className="border border-gray-400 p-2">
                          <select
                            value={row.gender}
                            onChange={(e) => handleGenderChange(index, e.target.value)}
                            className="border p-1 w-full"
                          >
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Other">Other</option>
                          </select>
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>
      </div>





    </>





  );
};

export default DynamicTable;
